export default "__VITE_ASSET__BqPn7$5Y__"